import { render, staticRenderFns } from "./SystemMange.vue?vue&type=template&id=6022074f&scoped=true"
import script from "./SystemMange.vue?vue&type=script&lang=js"
export * from "./SystemMange.vue?vue&type=script&lang=js"
import style0 from "./SystemMange.vue?vue&type=style&index=0&id=6022074f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6022074f",
  null
  
)

export default component.exports